import { makeStyles } from '@mui/styles';
export const minimalLoaderStyles = makeStyles(() => ({
    animate: {
        animation: 'fade-in 0.4s linear',
    },
    '@keyframes fade-in': {
        '0%': {
            opacity: '0.5',
        },
        '100%': {
            opacity: '1',
        },
    },
}), { name: 'FC_MinimalLoader' });
//# sourceMappingURL=minimalLoader.styles.js.map